import type { FC, ReactElement } from "react"

/**
 * Создает HOC без параметров
 * @param render функция рендер
 */
export const createHOC =
	(render: (element: ReactElement) => ReactElement, hocName = 'HOC') => (C: FC) => {
		const HOC = () => render(<C />)
		HOC.displayName = hocName + '_' + (C.displayName ?? C.name)
		return HOC
	}
